const selectors = {
  scrollbar: 'data-scrollbar-slider',
  scrollbarArrowPrev: '[data-scrollbar-arrow-prev]',
  scrollbarArrowNext: '[data-scrollbar-arrow-next]',
};

const classes = {
  hidden: 'is-hidden',
};

const times = {
  delay: 200,
};

class NativeScrollbar {
  constructor(scrollbar) {
    this.scrollbar = scrollbar;

    this.arrowNext = this.scrollbar.parentNode.querySelector(selectors.scrollbarArrowNext);
    this.arrowPrev = this.scrollbar.parentNode.querySelector(selectors.scrollbarArrowPrev);

    this.init();
    this.resize();

    if (this.scrollbar.hasAttribute(selectors.scrollbar)) {
      this.scrollToVisibleElement();
    }
  }

  init() {
    if (this.arrowNext && this.arrowPrev) {
      if (window.isRTL) {
        this.togglePrevArrow();
      } else {
        this.toggleNextArrow();
      }

      this.events();
    }
  }

  resize() {
    document.addEventListener('theme:resize', () => {
      if (window.isRTL) {
        this.togglePrevArrow();
      } else {
        this.toggleNextArrow();
      }
    });
  }

  events() {
    this.arrowNext.addEventListener('click', (event) => {
      event.preventDefault();

      this.goToNext();
    });

    this.arrowPrev.addEventListener('click', (event) => {
      event.preventDefault();

      this.goToPrev();
    });

    this.scrollbar.addEventListener('scroll', () => {
      this.togglePrevArrow();
      this.toggleNextArrow();
    });
  }

  goToNext() {
    const position = this.scrollbar.getBoundingClientRect().width / 2 + this.scrollbar.scrollLeft;

    this.move(position);

    this.arrowPrev.classList.remove(classes.hidden);

    this.toggleNextArrow();
  }

  goToPrev() {
    const position = this.scrollbar.scrollLeft - this.scrollbar.getBoundingClientRect().width / 2;

    this.move(position);

    this.arrowNext.classList.remove(classes.hidden);

    this.togglePrevArrow();
  }

  toggleNextArrow() {
    setTimeout(() => {
      if (window.isRTL) {
        this.arrowNext.classList.toggle(classes.hidden, this.scrollbar.scrollLeft === 0);
      } else {
        this.arrowNext.classList.toggle(classes.hidden, Math.round(this.scrollbar.scrollLeft + this.scrollbar.getBoundingClientRect().width + 1) >= this.scrollbar.scrollWidth);
      }
    }, times.delay);
  }

  togglePrevArrow() {
    setTimeout(() => {
      if (window.isRTL) {
        this.arrowPrev.classList.toggle(classes.hidden, Math.abs(this.scrollbar.scrollLeft) + this.scrollbar.getBoundingClientRect().width + 1 >= this.scrollbar.scrollWidth);
      } else {
        this.arrowPrev.classList.toggle(classes.hidden, this.scrollbar.scrollLeft <= 0);
      }
    }, times.delay);
  }

  scrollToVisibleElement() {
    [].forEach.call(this.scrollbar.children, (element) => {
      element.addEventListener('click', (event) => {
        if (
          event.target.tagName.toLowerCase() === 'a' ||
          (event.currentTarget && event.currentTarget.tagName.toLowerCase() === 'a') ||
          (event.currentTarget && event.currentTarget.querySelector('a'))
        ) {
          event.preventDefault();
        }

        this.move(element.offsetLeft - element.clientWidth);
      });
    });
  }

  move(offsetLeft) {
    this.scrollbar.scrollTo({
      top: 0,
      left: offsetLeft,
      behavior: 'smooth',
    });
  }
}

export default NativeScrollbar;
